import { ClipboardCheck } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'
import {
	formatTestRoutineSummary,
	testRoutineCardTitle,
	type TestRoutineDraft,
} from '#app/routes/mocra+/_form+/components/test-routines/types.ts'

type Props = {
	readonly index: number
	readonly routine: TestRoutineDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function TestRoutineCard({
	index,
	routine,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = testRoutineCardTitle(routine, index)
	const description = formatTestRoutineSummary(routine)
	const hasErrors = Boolean(errors && errors.length > 0)

	return (
		<EntityCard
			title={title}
			description={hasErrors ? `${description} • Needs attention` : description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle="Remove this test routine?"
			removeConfirmDescription="This test routine will be removed from the list."
			icon={
				<ClipboardCheck
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
		/>
	)
}
